/**
 * The entryway: post-login landing for DWA users. A tile per Hub the user can see
 * (src/hubs/hubs.ts). Client-role users never reach this page — they go straight
 * to their own dashboard (routes/AppRoutes.tsx).
 */
import React from 'react';
import BrandIcon from '../assets/DWA_WolfHead_Favicon_Web.png';
import { useAuth } from '../contexts/AuthContext';
import { DWA } from '../theme/dwaTokens';
import { greetingName, visibleHubs } from '../hubs/hubs';
import { GradientPage, HubTile } from '../hubs/HubCards';
import { UserMenu } from '../hubs/UserMenu';

export const EntrywayPage: React.FC = () => {
  const { user } = useAuth();
  const hubs = visibleHubs(user);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <GradientPage>
        <header
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '1rem clamp(1rem, 4vw, 2rem)',
            gap: '1rem',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', minWidth: 0 }}>
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: '50%',
                background: `linear-gradient(135deg, ${DWA.dark}, ${DWA.darkSoft})`,
                border: '1px solid rgba(254,195,92,0.4)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <img src={BrandIcon} alt="" style={{ width: 28, height: 28, objectFit: 'cover' }} />
            </div>
            <div style={{ minWidth: 0 }}>
              <h1 style={{ fontSize: '1.15rem', fontWeight: 700, margin: 0, color: '#ffffff' }}>Omega Wolf</h1>
              <p style={{ fontSize: '0.75rem', margin: 0, color: DWA.onDarkMuted }}>Digital Wolf Agency</p>
            </div>
          </div>
          <UserMenu variant="light" />
        </header>

        <main
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '1.5rem clamp(1rem, 4vw, 2rem) 6rem',
            gap: '2rem',
          }}
        >
          <div style={{ textAlign: 'center' }}>
            <h2 style={{ fontSize: 'clamp(1.4rem, 4vw, 1.9rem)', fontWeight: 700, margin: '0 0 0.4rem', color: '#ffffff' }}>
              Welcome back, {greetingName(user)}
            </h2>
            <p style={{ fontSize: '0.95rem', margin: 0, color: DWA.onDarkMuted }}>Choose a Hub.</p>
          </div>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 240px), 1fr))',
              gap: '1.25rem',
              width: '100%',
              maxWidth: 1100,
            }}
          >
            {hubs.map((hub) => (
              <HubTile key={hub.id} hub={hub} />
            ))}
          </div>
        </main>
      </GradientPage>
    </div>
  );
};

export default EntrywayPage;
